import { useDataIsSubmitting, useDataValue, useDataSubmit } from 'Simple/Data'
import { email as isValidEmail } from 'Data/validate.js'

export function useDisabled(props) {
  let isSubmitting = useDataIsSubmitting({
    viewPath: props.viewPath,
    context: 'selected',
  })
  let email = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'email',
  })

  return isSubmitting || !isValidEmail(email)
}
